import React  from 'react';
import {insertOrUpdateSchedule} from '../../util/APIUtils';
import {SESSION_USER,JOB_PRIORITY_LOW,JOB_PRIORITY_MEDIUM,JOB_PRIORITY_HIGH} from '../../constants';
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Select from 'react-select';

const options = [
  { value: JOB_PRIORITY_HIGH, label: 'High' },
  { value: JOB_PRIORITY_MEDIUM, label: 'Medium' },
  { value: JOB_PRIORITY_LOW, label: 'Low' }
];


class External extends React.Component {
    
 constructor(props) {
        super(props);
        this.state = { 
            modalShow: false,
            title: '',
            priority:''
        };
        this.initeachevent=this.initeachevent.bind(this);   
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);

        this.createExternalEvent=this.createExternalEvent.bind(this);  

  }

  handleClose() {
    this.setState({ modalShow: false });
  }

  handleSave() {
    let user = JSON.parse(localStorage.getItem(SESSION_USER));
   
    const title=this.state.title;
    const priority=this.state.priority.value;
    
    if(!title){
      return false;
    }

    var fields={};
    
    fields["userId"] = user.id;
    fields["title"] = title;
    fields["priority"] = priority;
    console.log(fields);
         
           insertOrUpdateSchedule(fields)
           .then(response => {   
             console.log(response);
             this.createExternalEvent(priority,title,response.id)

          }).catch(error => {             
           this.setState({
            serverError: true,
          });   
         })
         



   


     this.setState({
         title:'',priority:''
     });
     
     this.setState({ modalShow: false });
  }

    createExternalEvent(priority,title,scheduleId){ 
     var texthtml='<div class="calendar-events"  data-time="10:30"  data-title='+title+'  data-priority='+priority+' id='+scheduleId+'><i class="ti-menu threeline"></i>'+title+'';
     texthtml+='<br/><small><i class="mdi mdi-av-timer"></i>10&nbsp;Hours</small></div>';
     $('#calendar-event').append(texthtml);
     this.initeachevent();
    }

    componentDidMount() {
      //  this.state = { modalShow: false };
        this.initeachevent();
    }


    initeachevent(){
   
      $('#calendar-event .calendar-events').each(function() {  

           var eventId=$(this).attr('id');
          // console.log(eventId);

            $(this).data('event', {
                title: $.trim($(this).text()), 
                id:eventId,
               // defaultTimedEventDuration:$(this).data('defaultTimedEventDuration'),
                stick: true 
            });
            $(this).draggable({
              //  appendTo: 'body',
               // containment: 'page-wrapper',
                scroll: false,
                helper: 'clone',
                zIndex: 999,
                revert: true,      
                revertDuration: 0  
            });
        });
        
    }

   handleChange(event) {      
      const target = event.target;   
      const inputValue = target.value;
      this.setState({
       [target.name] : inputValue
     });
    }

    onSelectChange(value){
      const target = value;   
     //console.log(target);
     // if(!this.state.loading){
       this.setState({priority: target});
    // }

    }


  

    render() {
        return <div className="col-md-3">
            <div className="card">
                <div className="card-body">
                    <h6 className="card-title">Unscheduled Jobs&nbsp;&nbsp; 

                    <span  className="mytooltip"> 

                            <i className="fa fa-info-circle"></i>
                             <span className="tooltip-content5">
                             <span className="tooltip-text">
                             <span className="tooltip-inner2">
                             <i className="fa fa-circle text-danger high"></i>  High <br/>
                             <i className="fa fa-circle text-warning med"></i>  Medium <br/>
                              <i className="fa fa-circle text-success low"></i>  Low <br/>
                             </span>
                             </span>
                             </span>
                         </span> </h6>
                    


                    <div className="row" id="slimtest4">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            
                        
                            <div id="calendar-event" className="m-t-20" style={{overflowY:'scroll',height:'550px'}}>

                                

                               {this.props.unschedule.map((item, key) =>
                                   
                                   <div className='calendar-events'   data-time={item.estimatedHours} data-priority={item.priority} data-title={item.title}   id={item.id+'_wo'} key={ key }>
                                       <i className="ti-menu threeline"></i>
                                      
                                   
                                   {item.title}<br/>
                                    <small><i className="mdi mdi-av-timer"></i>{item.estimatedHours}&nbsp;Hours</small>
                                   
                                   </div>    
                               )}

                             

                            </div>
                            
                              <Button style={{display:'none'}} variant="primary" onClick={() => this.setState({ modalShow: true })}  size="sm" block className="btn btn-sm m-t-40 btn-info btn-block waves-effect waves-light">
                                <i className="ti-plus"></i> Add New Schedule
                              </Button>
                             
                        
                          <Modal show={this.state.modalShow} onHide={this.handleClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>Add Schedule</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>

                               <form>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="control-label">Title</label>
                                            <input className="form-control form-white" placeholder="Enter name" type="text" name="title" id="title"  value={this.state.title} onChange={this.handleChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="control-label">Priority</label>
                                            

                                  <Select options={options}  name="priority" id="priority" value={this.state.priority}   onChange={this.onSelectChange.bind(this)}
                                  />
                                           
                           
             </div>
                                    </div>
                                </form>


                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={this.handleClose}>
                                  Close
                                </Button>
                                <Button variant="primary" onClick={this.handleSave}>
                                  Save Changes
                                </Button>
                              </Modal.Footer>
                            </Modal>

                        </div>
                    </div>

                  
                </div>
            </div>
        </div>;
    }
   
}

export default External